import React, { useMemo, useState } from "react";
import Select from "react-select";

const PAGE_SIZE = 50;

const CustomerSelect = ({ options, ...props }) => {
  const [inputValue, setInputValue] = useState("");
  const [visibleLimit, setVisibleLimit] = useState(PAGE_SIZE);

  const matchingOptions = useMemo(() => {
    const search = inputValue.trim().toLowerCase();
    return search
      ? options.filter((option) => option.label.toLowerCase().includes(search))
      : options;
  }, [options, inputValue]);

  const visibleOptions = useMemo(
    () => matchingOptions.slice(0, visibleLimit),
    [matchingOptions, visibleLimit],
  );

  return (
    <Select
      {...props}
      options={visibleOptions}
      inputValue={inputValue}
      filterOption={null}
      onInputChange={(value, { action }) => {
        setInputValue(action === "input-change" ? value : "");
        setVisibleLimit(PAGE_SIZE);
      }}
      onMenuScrollToBottom={() => {
        setVisibleLimit((limit) =>
          Math.min(limit + PAGE_SIZE, matchingOptions.length),
        );
      }}
    />
  );
};

export default CustomerSelect;
